import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { motion } from "framer-motion";

import StatsCard from "./StatsCard";
import PieChartCard from "./PieChartCard";
import LeadsTable from "./LeadsTable";
import BarChartCard from "./BarChartCard";

const Container = styled(Box)(({ theme }) => ({
  minHeight: "100vh",
  background: "#fff",
  display: "flex",
  flexDirection: "row",
  overflow: "hidden",
  transform: "scale(0.97)",
  transformOrigin: "center",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    transform: "scale(0.95)",
    marginTop: theme.spacing(-5),
  },
}));

const Content = styled(Box)<{ component?: React.ElementType }>(({ theme }) => ({
  width: "100%",
  maxWidth: "auto",
  padding: theme.spacing(1),
  marginTop: theme.spacing(0),
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(0),
    maxWidth: "100%",
    marginTop: theme.spacing(0),
  },
}));

const WelcomeText = styled(Typography)(({ theme }) => ({
  fontSize: "28px",
  fontWeight: 600,
  color: "#4b5b5d",
  textAlign: "left",
  [theme.breakpoints.down("sm")]: {
    fontSize: "20px",
  },
}));

const TrackLeadsDashboard = () => {
  return (
    <Container>
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2, ease: "easeOut" }}
        style={{
          width: "100%",
          maxWidth: "auto",
          marginTop: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Content component="form">
          <WelcomeText>Track Your Leads</WelcomeText>
          <Grid container spacing={{ xs: 2, sm: 3, md: 4 }}>
            <Grid size={{ xs: 12 }}>
              <StatsCard />
            </Grid>
          </Grid>
          <Grid container spacing={{ xs: 2, sm: 3, md: 4 }}>
            <Grid size={{ xs: 12 }}>
              <LeadsTable />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={{ xs: 2, sm: 3, md: 4 }}
            sx={{ mt: { xs: 2, sm: 3 } }}
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <PieChartCard />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 8 }}>
              <BarChartCard />
            </Grid>
          </Grid>
        </Content>
      </motion.div>
    </Container>
  );
};

export default TrackLeadsDashboard;
